import { render } from "./UserGroups.vue?vue&type=template&id=3556598d&scoped=true"
import script from "./UserGroups.vue?vue&type=script&lang=js"
export * from "./UserGroups.vue?vue&type=script&lang=js"

import "./UserGroups.vue?vue&type=style&index=0&id=3556598d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3556598d"

export default script